import React, { useMemo } from 'react';
import { Row, Col } from 'reactstrap'

const ExtractedText: React.FC<{
  text: string;
  view: 'text' | 'redacted';
  searchTerm?: string;
  redactedHTML?: string;
}> = ({ text, view, searchTerm, redactedHTML }) => {
  const textToDisplay = useMemo(() => {
    let newText = text;
    if (view === 'text') {
      return newText;
    }

    // let redactedText = text;
    // for (const key in (mapping || {})) {
    //   redactedText = redactedText.replace(new RegExp(key, 'ig'), `<strike style="color: red">${key}</strike>&nbsp;<b style="color: green">${mapping![key]}</b>`);
    // }
    return redactedHTML || '';
  }, [text, view, redactedHTML]);

  const safeSearchTerm = useMemo(() => {
    if (!searchTerm) return ''
    return searchTerm.replace(/\\/g, '\\\\').replace(/\[/g, '\\[').replace(/\]/g, '\\]').replace(/\(/g, '\\(').replace(/\)/g, '\\)').replace(/\{/g, '\\{').replace(/\}/g, '\\}').replace(/\./g, '\\.').replace(/\*/g, '\\*').replace(/\+/g, '\\+').replace(/\?/g, '\\?').replace(/\^/g, '\\^').replace(/\$/g, '\\$').replace(/\|/g, '\\|').replace(/\//g, '\\/')
  }, [searchTerm])

  return (
    <Row className="extracted-row">
      <Col
        xs="12"
        style={{
          overflowWrap: "break-word",
          maxHeight: "80vh",
          overflowY: "scroll",
        }}
      >
        {
          searchTerm ?
            <div style={{
              letterSpacing: ".01em",
              lineHeight: "1.8em"
            }} dangerouslySetInnerHTML={{
              __html: textToDisplay.replace(new RegExp(safeSearchTerm, 'ig'), `<span style="background-color: #fb6340; color: #fff; border-radius: 3px; padding: 0 5px; line-height: 1.8em; letter-spacing: .08em; font-weight: 600; opacity: .9;">${searchTerm}</span>`)
            }} />
            :
            <div style={{
              letterSpacing: ".01em",
              lineHeight: "1.8em"
            }} dangerouslySetInnerHTML={{ __html: textToDisplay }} />
        }
      </Col>
    </Row>
  )
}

export default ExtractedText;
